import Auth from '../modules/Authentication'
import { apiUrl } from '../variables/index'
import { handleErrors, handleResponse } from '../modules/Utils'
import Authentication from '../modules/Authentication'

export default class User {
  auth = new Auth()
  login = (user) => {
    const headers = {}
    return fetch(`${apiUrl}profiles/login/`, {
      headers,
      method: 'POST',
      body: JSON.stringify(user),
    }).then(handleErrors)
  }
  logout = () => {
    const headers = {}
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}profiles/logout/`, {
      headers,
      method: 'POST',
    }).then(handleErrors)
  }
  member = (token) => {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.auth.getAccessToken(),
    }
    return fetch(`${apiUrl}profiles/member`, {
      headers,
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  create = (data) => {
    const headers = {}
    headers['Authorization'] = 'Bearer ' + this.auth.getAccessToken()

    return fetch(`${apiUrl}profiles/`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }

  update = (user) => {
    const headers = {}
    headers['Authorization'] = 'Bearer ' + this.auth.getAccessToken()
    headers['x-access-token'] = this.auth.getAccessToken()
    return fetch(apiUrl + `/profiles/password`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(user),
    }).then(handleErrors)
  }
  updateUser = (user) => {
    const headers = {}
    headers['Authorization'] = 'Bearer ' + this.auth.getAccessToken()
    headers['x-access-token'] = this.auth.getAccessToken()
    return fetch(apiUrl + `/profiles`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(user),
    }).then(handleErrors)
  }
  read = (key) => {
    const headers = {}
    headers['Authorization'] = 'Bearer ' + this.auth.getAccessToken()
    return fetch(`${apiUrl}profiles/${key}`, {
      headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  list = () => {
    const headers = {}
    return fetch(`${apiUrl}profiles/employees/`, {
      headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  active = () => {
    const headers = {}
    headers['Authorization'] = 'Bearer ' + this.auth.getAccessToken()
    return fetch(apiUrl + `/profiles/active`, {
      headers: headers,
      method: 'PATCH',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
}
const auth = new Authentication()
export const extranet = {
  getUser: (key) => {
    const headers = {}
    headers['Authorization'] = 'Bearer ' + auth.getAccessToken()
    return fetch(apiUrl + `/oauth/users/members/${key}`, {
      headers: headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  updateUser: (key, data) => {
    const headers = {}
    headers['Authorization'] = 'Bearer ' + auth.getAccessToken()
    return fetch(apiUrl + `/oauth/userclient`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
}
